<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Assign which premium rules each partner is allowed to access &amp; sell.</p>
        </div>
        <p-button label="Assign Premiums" icon="pi pi-plus" (onClick)="openAssign()" />
    </div>

    <div class="card">
        <div class="toolbar">
            <p-iconfield iconPosition="left" class="search-field">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText placeholder="Search partner, code or premium..." [ngModel]="search()"
                    (ngModelChange)="search.set($event)" />
            </p-iconfield>
            <div class="filter">
                <label>Partner</label>
                <p-select [ngModel]="partnerFilter()" (ngModelChange)="onPartnerFilter($event)"
                    [options]="partnerOptions()" optionLabel="label" optionValue="id" [filter]="true"
                    filterBy="label" [showClear]="true" placeholder="All partners" appendTo="body" />
            </div>
            <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
        </div>

        <p-table [value]="filtered()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Partner</th>
                    <th>Premium</th>
                    <th>Coverage</th>
                    <th>Enabled</th>
                    <th>Created</th>
                    <th class="ta-r">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-r>
                <tr>
                    <td class="name">
                        {{ r.partnerName }}
                        @if (r.partnerCode) { <span class="mono">{{ r.partnerCode }}</span> }
                    </td>
                    <td class="mono">{{ r.premiumCode }}</td>
                    <td>{{ r.coverageType }}</td>
                    <td>
                        <p-tag [value]="r.isEnable ? 'ENABLED' : 'DISABLED'"
                            [severity]="r.isEnable ? 'success' : 'secondary'" />
                    </td>
                    <td>{{ r.createdDate | indDate }}</td>
                    <td class="ta-r actions">
                        <p-button [icon]="r.isEnable ? 'pi pi-check-circle' : 'pi pi-ban'" [rounded]="true"
                            [text]="true" severity="secondary"
                            [pTooltip]="r.isEnable ? 'Disable' : 'Enable'" (onClick)="toggleEnable(r)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(r)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">
                        <div class="state"><i class="pi pi-inbox"></i>
                            <p>No assignments found. Click "Assign Premiums" to add some.</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ASSIGN MODAL ===================== -->
<p-dialog [visible]="showAssign()" (visibleChange)="showAssign.set($event)" [modal]="true" [draggable]="true"
    [resizable]="false" [closable]="true" [dismissableMask]="false" header="Assign Premiums to Partner"
    styleClass="menu-dialog" [style]="{ width: '560px' }" [breakpoints]="{ '560px': '94vw' }">
    <div class="menu-form">
        <div class="field">
            <label>Partner <span class="req">*</span></label>
            <p-select [ngModel]="assignPartnerId()" (ngModelChange)="onAssignPartnerChange($event)"
                [options]="partnerOptions()" optionLabel="label" optionValue="id" [filter]="true"
                filterBy="label" placeholder="Select a partner..." appendTo="body" />
        </div>

        <div class="field">
            <label>Premiums <span class="req">*</span></label>
            <p-multiSelect [ngModel]="assignPremiumIds()" (ngModelChange)="assignPremiumIds.set($event)"
                [options]="premiumOptions()" optionLabel="label" optionValue="id" [filter]="true"
                filterBy="label" display="chip" placeholder="Select premium rules..." appendTo="body"
                [showHeader]="true" />
            <small class="hint-muted">
                Already-assigned premiums are pre-ticked and will be skipped on save.
            </small>
        </div>

        <label class="check">
            <p-toggleSwitch [ngModel]="assignEnable()" (ngModelChange)="assignEnable.set($event)" />
            Enabled
        </label>

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeAssign()" />
            <p-button label="Assign" icon="pi pi-check" (onClick)="saveAssign()" [disabled]="saving()"
                [loading]="saving()" />
        </div>
    </div>
</p-dialog>
